import { gql } from 'apollo-angular';
import { qualityInstrumentItemFragment } from '../quality-instrument/quality-instrument.fragments';

export const eventCardItemFragment = gql`
  fragment EventCardItemFragment on EventCard {
    id
    title
    descriptionJsonContent
    archivedAt
    completedAt
    createdAt
    endDate
    startDate
    eventCardStatus
    qualityInstrument {
      ...QualityInstrumentItem
    }
  }
  ${qualityInstrumentItemFragment}
`;

export const eventCardItemForExportFragment = gql`
  fragment EventCardItemForExportFragment on EventCard {
    id
    title
    descriptionJsonContent
    archivedAt
    completedAt
    createdAt
    endDate
    startDate
    eventCardStatus
    qualityInstrument {
      ...QualityInstrumentItem
    }

    linkedCards {
      ... on GoalCard {
        id
        title
        endDate
        startDate
      }
      ... on EventCard {
        id
        title
        endDate
        startDate
      }
    }
  }
  ${qualityInstrumentItemFragment}
`;
